import { GridActionsCellItem, GridDeleteIcon, GridRowParams, GridViewColumnIcon } from "@mui/x-data-grid"
import { useContext } from "react"
import { Button, Grid, Input, Layout, Loader, LoaderContainer, Modal, Paper, Table } from "../../components"
import { AuthContext } from "../../contexts"
import DownloadIcon from '@mui/icons-material/Download';
import { useAPI, useToggle } from "../../hooks";
import { enqueueSnackbar } from "notistack";
import { formatDateTime } from "@bussola-viagens/utils";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CreateTrainingSchema } from "@bussola-viagens/validations";

export const TrainingsPage = () => {
    const navigate = useNavigate()
    const [modal, modalControls] = useToggle(false)
    const [trainings, refetchTrainings] = useAPI(`/training`)
    const [createdTraining, createTraining] = useAPI({}, {manual: true})

    const form = useFormik({
        initialValues: {
            name: ''
        },
        validationSchema: CreateTrainingSchema,
        onSubmit: async (data, helpers) => {
            const { status } = await createTraining({
                url: `/training`,
                data,
                method: 'POST'
            })

            if (status <= 299) {
                enqueueSnackbar('Treinamento criado com sucesso!', { variant: 'success' })
                modalControls.setFalse()
                helpers.resetForm()
                refetchTrainings()
            }
        }
    })

    if (trainings.loading) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    return (
        <Layout>
            <Grid container p={1} justifyContent="center" spacing={1}>
                <Grid item xs={10} textAlign="right">
                    <Button
                        onClick={modalControls.setTrue}
                    >
                        Adicionar
                    </Button>
                </Grid>
                <Grid item xs={10}>
                    <Paper>
                        <Table 
                            columns={[
                                { field: 'created_at', flex: 1, type: 'dateTime', headerName: 'Data de Criação', valueGetter: (value) => new Date(value), valueFormatter: formatDateTime },
                                { field: 'name', flex: 1, type: 'string', headerName: 'Nome' },
                                { field: 'lessons', flex: 1, type: 'number', headerName: 'Aulas', valueGetter: (value: Array<string>) => value.length },
                                { field: 'actions', type: 'actions', getActions: (params: GridRowParams) => [
                                    <GridActionsCellItem 
                                        icon={<VisibilityIcon />} 
                                        onClick={() => {
                                            navigate(`/treinamentos/${params.id}`)
                                        }} 
                                        label="Ver Detalhes" 
                                    />,
                                ] }
                            ]}
                            rows={trainings.data || []}
                        />
                    </Paper>
                </Grid>
            </Grid>
            {modal && (<Modal
                title="Novo Treinamento"
                open={modal}
                onConfirm={form.handleSubmit}
                confirmLabel="Adicionar"
                bodyCustomCss={{
                    width: 400
                }}
                onClose={modalControls.setFalse}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <Input 
                            name="name"
                            label="Nome"
                            value={form.values.name}
                            onChange={form.handleChange}
                            error={!!form.touched.name && !!form.errors.name}
                            helperText={form.touched.name && form.errors.name}
                        />
                    </Grid>
                </Grid>
            </Modal>)}
        </Layout>
    )
}